import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TabTitle from "../components/TabTitle"; // Importa o componente de atualização do título
import logo from "../assets/logo1.png"; // Certifique-se de que o caminho está correto
import "./LandingPage.css";

const LandingPage = () => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleNavigate = (path) => {
    navigate(path);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const selectLanguage = (language) => {
    console.log(`Idioma selecionado: ${language}`);
    setShowDropdown(false);
  };

  const handleContinue = () => {
    navigate("/login");
  };

  return (
    <>
      {/* Atualiza o título da aba */}
      <TabTitle activeTab="LandingPage" />

      <div className="landing-page">
      {/* Header */}
<header className="landing-header">
  <img src={logo} alt="Logo" className="header-logo" />
  <h1 className="header-title">Welcome</h1>

  <nav className="header-nav">
  <button
    className="nav-button"
    onClick={() => handleNavigate("/software")}
  >
    Software
  </button>

  <button
    className="nav-button"
    onClick={() => handleNavigate("/portal-pagamento")}
  >
    Débitos
  </button>

  <button
    className="nav-button"
    onClick={() => handleNavigate("/contactos")}
  >
    Contactos
  </button>

  <div className="dropdown-container">
    <button className="nav-button" onClick={toggleDropdown}>
      Idioma
    </button>

    {showDropdown && (
      <div className="dropdown-menu">
        <button
          className="dropdown-item"
          onClick={() => selectLanguage("Português")}
        >
          Português
        </button>
        <button
          className="dropdown-item"
          onClick={() => selectLanguage("Inglês")}
        >
          Inglês
        </button>
      </div>
    )}
  </div>
</nav>

</header>

        {/* Conteúdo principal */}
        <main className="landing-main">
          <h2>Bem-vindo(a) ao</h2>
          <h3>ACADE - Gestor Escolar</h3>
          <h4>Simplifique e potencialize a gestão da sua instituição com uma plataforma moderna, intuitiva e eficiente.  </h4>
          <h5>Tenha controle total sobre alunos, professores, finanças e muito mais.<strong class="strong-blue">Experimente agora!</strong> </h5>

        
          <button className="continue-button" onClick={handleContinue}>
            Continuar para Login
          </button>
        </main>

        {/* Footer */}
        <footer className="landing-footer">
          <p>© 2024-2025 Desenvolvido por Chaúca Creative, Lda. Todos os direitos reservados.</p>
        </footer>
      </div>
    </>
  );
};

export default LandingPage;
